import { render } from "./AdicionarModelo.vue?vue&type=template&id=c3fb33b6&scoped=true&ts=true"
import script from "./AdicionarModelo.vue?vue&type=script&lang=ts"
export * from "./AdicionarModelo.vue?vue&type=script&lang=ts"

import "./AdicionarModelo.vue?vue&type=style&index=0&id=c3fb33b6&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3fb33b6"]])

export default __exports__